export const NEW_BUILD_POLL_INTERVAL_MS = 60_000;

export const NEW_BUILD_DISMISSED_KEY = 'ndia5_new_build_dismissed_id';

export const NEW_BUILD_VERSION_PATH = '/version.json';
